
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Blast } from "src/app/services/hole.service";
import { HolesStatusChartComponent } from "../../holes-status-chart/holes-status-chart.component";
import { BlastLoadingListComponent } from "../../holes-load-list/holes-load-list.component";

@Component({
  selector: "app-blast-load-informations",
  templateUrl: "./blast-load-informations.component.html",
  styleUrls: ["./blast-load-informations.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslateModule,
    HolesStatusChartComponent,
    BlastLoadingListComponent
],
})
export class BlastLoadInformationsComponent {
  readonly blast = input<Blast | null>(null);
  readonly qualityData = input<any>(null);
  readonly tirId = input<number>(null);
  readonly selectedHoleId = input<string | null>(null);

  readonly addHole = output<void>();
  readonly holeSelected = output<{ holeId: string | null; changeCollapsed: boolean }>();
  readonly collapseChanged = output<boolean>();

  readonly isCollapsed = signal(false);

  toggleCollapse(): void {
    this.isCollapsed.update(v => !v);
    this.collapseChanged.emit(this.isCollapsed());
  }

  onAddHole(): void {
    this.addHole.emit();
  }

  onHoleSelected(holeId: string | null): void {
    this.holeSelected.emit({ holeId: holeId, changeCollapsed: true });
  }
}
